export enum LinkTarget {
    Modal = 'modal',
    Blank = 'blank',
    Internal = 'internal',
    Silent = 'silent',
}
